import React from "react";

type FeatureCardProps = {
  icon: React.ReactNode;
  title: string;
  desc?: string;
  onClick?: () => void;
};

export default function FeatureCard({ icon, title, desc, onClick }: FeatureCardProps) {
  return (
    <div
      className={`p-4 transition text-center bg-white border-green-200 border rounded-lg shadow ${onClick ? "cursor-pointer hover:bg-green-50" : "cursor-default opacity-70"}`}
      onClick={onClick}
      tabIndex={onClick ? 0 : -1}
      role="button"
      aria-disabled={!onClick}
    >
      {icon}
      <div className="text-lg font-semibold text-green-800">{title}</div>
      {desc && <div className="mt-1 text-xs text-gray-500">{desc}</div>}
    </div>
  );
}